import React from 'react';
import SendEmailForm from './SendEmailForm';
import { ClientService } from '../../services/client/clientService';

interface SendClientEmailFormProps {
    onClose: () => void;
    clientId: string;
}

const SendClientEmailForm: React.FC<SendClientEmailFormProps> = ({ onClose, clientId }) => {
    const clientService = {
        sendEmail: (data: any) => new ClientService().sendClientEmail(data)
    };

    return (
        <SendEmailForm
            onClose={onClose}
            entityType="client"
            entityId={clientId}
            service={clientService}
            entityFieldName="clientId"
        />
    );
};

export default SendClientEmailForm;